import { ApproveSquirrel } from 'Icons'

const NoPostToApprove: React.FC = () => {
  return (
    <div className="relative h-[45px] overflow-hidden whitespace-nowrap rounded-[5px] border border-solid border-green-500 bg-[#f0f8e7] py-3.5 text-center font-bold text-green-500">
      <div className="absolute left-1/2 w-full -translate-x-1/2 -translate-y-1/2 pb-[11px] [&>svg]:relative [&>svg]:-left-[5px] [&>svg]:top-5 [&>svg]:inline-block [&>svg]:w-[50px] [&>span]:relative [&>span]:top-1 [&>span]:text-sm max-[1280px]:[&>span]:ml-[10px]">
        <span>No posts awaiting approval.</span>
        <ApproveSquirrel />
      </div>
    </div>
  )
}

export default NoPostToApprove
